import React from 'react';

import { Switch, Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import TripReport from './Trip/ReportsSection';
import EventReport from './Event/ReportsSection';
import GeofenceReport from './Geofence/ReportsSection';
import RavenReport from './Raven/ReportsSection';
import AssetReport from './Asset/ReportsSection';
import DTCReport from './DTC/ReportsSection';
import StopsReport from './Stops/ReportsSection';
import ActivityReport from './Activity/ReportsSection';
import cubejs from "@cubejs-client/core";
import { strings } from 'APP_ROOT/localization';
import MyCubejsHttpTransport from "./MyCubejsHttpTransport";

import LambdaUtil from 'APP_ROOT/components/aws/lambda/lambdaUtil';

export default class ReportsSection extends React.PureComponent {

    constructor(props) {

        super(props);

        this.controller = new AbortController();

        this.state = {
            error: undefined,
            cubejsApi: undefined,
        }
    }


    componentDidMount() {
        const stage = this.props.user.stage;
        LambdaUtil.getReportingToken(stage).then(data => {
            const payload = JSON.parse(data.Payload);
            if (payload.status === "SUCCESS") {
                /* Redirect to the URL provided */

                var transport = new MyCubejsHttpTransport( { 
                      authorization: payload.token,
                      apiUrl: payload.apiUrl,
                      signal: this.controller.signal
                });

                this.setState({
                    cubejsApi: cubejs(
                        payload.token,
                        { 
                            apiUrl: payload.apiUrl,
                            transport: transport
                        }
                    )
                });
            } else {
                console.error(payload);
                this.setState({
                    error: 'An error occurred authenticating with the reporting system (1)'
                });
            }
        }).catch(error=> {
            console.error(error);
            this.setState({
                error: 'An error occurred authenticating with the reporting system (2)'
            });
        });
    }

    componentWillUnmount(){
        this.controller.abort();
    }
  
    limitToFilteredResources = (rawData, filteredResources) => {

        if(!filteredResources) return rawData;
        
        let filteredData = rawData;

        if(filteredResources.ravens){
            filteredData = filteredData.filter(row => {
                return row["DimRaven.uuid"] && filteredResources.ravens.includes(row['DimRaven.uuid']);
            });
        }

        // Other resources will be added here (geofences, assets, etc)

        return filteredData;
    }

    renderReport = ReportComponent => {
        return (
            <ReportHolder
                error={this.state.error}
                ReportComponent={ReportComponent}
                cubejsApi={this.state.cubejsApi}
                user={this.props.user}
                groupBy={this.props.groupBy}
                limitTo={this.props.limitTo}
                limitToFilteredResources={this.limitToFilteredResources}
                showDrivingParking={this.props.showDrivingParking}
                selectedDateRange={this.props.selectedDateRange}
                unitOfMeasure={this.props.unitOfMeasure}
                features={this.props.features}
            />
        );
    }

    renderTrip = () => {
        return this.renderReport(TripReport);
    }

    renderEvent = () => {
        return this.renderReport(EventReport);
    }

    renderGeofence = () => {
        return this.renderReport(GeofenceReport);
    }

    renderRaven = () => {
        return this.renderReport(RavenReport);
    }

    renderAsset = () => {
        if (!this.props.canAccessAssetsReport) {
            return <Redirect to={`/${this.props.match.params.lang}/stats/reports/trip`} />;
        }

        return this.renderReport(AssetReport);
    }

    renderDTC = () => {
        return this.renderReport(DTCReport);
    }

    renderStops = () => {
        return this.renderReport(StopsReport);
    }

    renderActivity = () => {
        return this.renderReport(ActivityReport);
    }

    render() {
        return (
            <Switch>
                <Route path='/:lang/stats/reports/vehicle'
                    render={this.renderTrip}
                />

                <Route path='/:lang/stats/reports/trip'
                    render={this.renderTrip}
                />

                <Route path='/:lang/stats/reports/event'
                    render={this.renderEvent}
                />

                <Route path='/:lang/stats/reports/geofence'
                    render={this.renderGeofence}
                />

                <Route path='/:lang/stats/reports/raven'
                    render={this.renderRaven}
                />

                <Route path='/:lang/stats/reports/asset'
                    render={this.renderAsset}
                />

                <Route path='/:lang/stats/reports/dtc'
                    render={this.renderDTC}
                />

                <Route path='/:lang/stats/reports/stops'
                    render={this.renderStops}
                />

                <Route path='/:lang/stats/reports/activity'
                    render={this.renderActivity}
                />

                <Redirect to={`/${this.props.match.params.lang}/stats/reports/trip`} />
            </Switch>
        );
    }

}

const ReportHolder = ({
    error,
    ReportComponent,
    cubejsApi,
    ...reportProps
}) => {
    if (error) {
        return <div>{error}</div>;
    }
    if(!cubejsApi) {
        return <div>{strings.loading}</div>;
    }
    return (
        <div className="row">
            <section className="col-12">
                <div className="report-table-wrapper">
                    <ReportComponent
                        cubejsApi={cubejsApi}
                        {...reportProps}
                    />
                </div>
            </section>
        </div>
    );
};

ReportsSection.propTypes = {
    user: PropTypes.shape({
        stage: PropTypes.string.isRequired
    }).isRequired,
    selectedDateRange: PropTypes.instanceOf(Array).isRequired,
    unitOfMeasure: PropTypes.string,
    groupBy: PropTypes.any,
    limitTo: PropTypes.any,
    showDrivingParking: PropTypes.bool,
    features: PropTypes.object,
    canAccessAssetsReport: PropTypes.bool,
    match: PropTypes.shape({
        params: PropTypes.shape({
            lang: PropTypes.string.isRequired
        }).isRequired
    }).isRequired
}
